import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {shiftFilterTitleInterface} from "../../../interfaces/shiftFilterTitleInterface";
import SelectionGridFiltersTitleDropdown from "./selectionGridFiltersTitleDropdown";

const SelectionGridFiltersTitle = (props) => {

  const {style, filterTitle, allTitles, filtersGrid, isTopTitle, isHorizontal} = props;

  const prevTitle = allTitles.find(renderFeature => {
    return renderFeature.titleIndex === filterTitle.titleIndex - 1
  });
  const nextTitle = allTitles.find(renderFeature => {
    return renderFeature.titleIndex === filterTitle.titleIndex + 1
  });

  const scrollToTitle = (title) => {
    if (isHorizontal) {
      const scrollLeft = title.titleIndex === 0 ? 0 : title.scrollLeft + 1
      // console.log("title to scroll", title);
      filtersGrid.current.scrollToPosition({scrollLeft});
    } else {
      const scrollTop = title.titleIndex === 0 ? 0 : title.scrollTop + 5
      // console.log("title to scroll", title);
      filtersGrid.current.scrollToPosition({scrollTop});
    }


    // const nextTitleElement = document.querySelector(`[data-title="${nextTitle.titleIndex}"]`);
    // console.log("nextTitleElement", nextTitleElement);
    //
    // if (nextTitleElement) {
    //   const computed = window.getComputedStyle(nextTitleElement);
    //   const top = computed.getPropertyValue('top')
    //   console.log("realTop.top", top);
    //   filtersGrid.current.scrollToPosition({scrollTop: top});
    // }
    // const {scrollTop} = filtersGrid.current.getOffsetForCell({rowIndex, columnIndex})
    // filtersGrid.current.scrollToPosition({scrollTop: scrollTop + 1});
    // filtersGrid.current.scrollToCell ({columnIndex, rowIndex});

    // animate({
    //   fromValue: this.scrollTop,
    //   toValue: offset,
    //   onUpdate: (scrollTop, callback) => this.setState({scrollTop}, callback),
    //   onComplete: () => console.log('Scroll animation complete!'),
    // });
  }

  const arrowUpDisabled = !prevTitle;
  const arrowDownDisabled = !nextTitle;

  return (
    <div style={style || {}} className={"ui-scroll-title"
    + (isHorizontal ? " ui-scroll-title--horizontal" : " ui-scroll-title--vertical")}
         data-title={filterTitle.titleIndex}>
      {isHorizontal ? (
        <span className="ui-scroll-title__text">{filterTitle.filterValue.displayText}</span>
      ) : (
        <SelectionGridFiltersTitleDropdown allTitles={allTitles}
                                           filterTitle={filterTitle}
                                           isTopTitle={isTopTitle}
                                           scrollToTitle={scrollToTitle}/>
      )}
      <div className="ui-scroll-title__arrows">
        <button disabled={arrowDownDisabled}
                onClick={!arrowDownDisabled ? () => scrollToTitle(nextTitle) : null}
                className="ui-scroll-title__arrows-arrow ui-scroll-title__arrows-arrow--down"/>
        <button disabled={arrowUpDisabled}
                onClick={!arrowUpDisabled ? () => scrollToTitle(prevTitle) : null}
                className="ui-scroll-title__arrows-arrow ui-scroll-title__arrows-arrow--up"/>
      </div>
    </div>
  )
}

SelectionGridFiltersTitle.propTypes = {
  style: PropTypes.object,
  filterTitle: PropTypes.shape(shiftFilterTitleInterface).isRequired,
  allTitles: PropTypes.array.isRequired,
  filtersGrid: PropTypes.any,
  isTopTitle: PropTypes.bool,
  isHorizontal: PropTypes.bool,
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(SelectionGridFiltersTitle)
